import React, { ChangeEvent, Component } from "react"
import { TextField, Dialog, FlatButton } from "material-ui"
import autobind from "class-autobind"
import ToolTip from "react-portal-tooltip"
import { guid } from "../../../helpers/utils"
import strings from "../../../localization/strings"
export interface JobsPerDate {
    Id: string
    Date: Date
    NumberOfJobs: number
}

interface IProps {
    handleCancel: () => void
    handleSave: (input: JobsPerDate) => void
    date: Date
    jobs: number
    isEdit: boolean
    isEmployeeSelected: boolean
    handleUpdate: (input: JobsPerDate) => void
    handleRemove: (id: string) => void
    Id: string | null
}

interface IState {
    jobs: number
    errorText: string
    showTooltip: boolean
}

const errorText = "Minimum of one job is required"
export class CalendarInput extends Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            jobs: this.props.isEdit ? this.props.jobs : 1,
            errorText: "",
            showTooltip: false
        }
        autobind(this)
    }

    handleSave() {
        if (this.state.jobs !== 0) {
            this.props.isEdit
                ? this.props.handleUpdate({ Date: this.props.date, NumberOfJobs: this.state.jobs, Id: this.props.Id })
                : this.props.handleSave({ Date: this.props.date, NumberOfJobs: this.state.jobs, Id: guid() })
        } else this.setState({ errorText })
    }

    checkValidity() {
        if (this.state.jobs === 0) this.setState({ errorText })
        else this.setState({ errorText: "" })
    }

    render() {
        return (
            <Dialog
                open
                title={"Add New Job"}
                actions={[
                    <FlatButton key="cancel" label={"Cancel"} secondary onTouchTap={this.props.handleCancel} />,
                    <FlatButton key="save" label={this.props.isEdit ? "Update" : "Save"} primary onTouchTap={this.handleSave} />,
                    this.props.isEdit && <FlatButton key="remove" label={"Remove"} primary onTouchTap={() => this.props.handleRemove(this.props.Id)} />
                ]}
                bodyStyle={{ padding: "0 20px", width: "300px" }}
            >
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <h2>{this.props.date.toISOString().slice(0, 10)}</h2>
                    <span
                        id={"calendarInput"}
                        onMouseEnter={() => this.setState({ showTooltip: this.props.isEmployeeSelected ? true : false })}
                        onMouseOut={() => this.setState({ showTooltip: false })}
                    >
                        <TextField
                            style={{ flex: 1 }}
                            floatingLabelText={"Number of Jobs"}
                            errorText={this.state.errorText}
                            value={this.state.jobs}
                            disabled={this.props.isEmployeeSelected}
                            onChange={(e: ChangeEvent<{ value }>) => this.setState({ jobs: isNaN(e.target.value) ? 0 : Number(e.target.value) }, () => this.checkValidity())}
                        />
                    </span>
                </div>
                <ToolTip active={this.state.showTooltip} position="right" arrow="center" parent={"#calendarInput"}>
                    <div style={{ padding: 5, width: 200, overflowY: "auto", maxHeight: 300 }}>{this.props.isEmployeeSelected && <span>{strings.One_job_can_be_assigned}</span>}</div>
                </ToolTip>
            </Dialog>
        )
    }
}
